import React, { ReactNode, forwardRef, RefObject } from 'react';
import styled from 'styled-components';

import { EnhancedCourseNavigation } from '@/administration/pages/Course/MainLayoutView/atoms/NavigationActions/EnhancedCourseNavigation';

const MultiPageStyled = styled.div`
  min-height: 100%;
  height: 100%;
  align-self: stretch;
  overflow-y: scroll;
`;

const PageBody = styled.div`
  background: ${({ theme }) => theme.tones.neutral[100]};
  border-radius: 20px;
  margin: 8px;

  min-height: calc(100% - 16px);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-bottom: 72px;
`;

export const MultiPageBody = forwardRef<
  HTMLDivElement,
  {
    children: ReactNode;
    backDisabled?: boolean;
    onBackClick: () => void;
    nextDisabled?: boolean;
    nextHidden?: boolean;
    onNextClick: () => void;
    isDrawerOpen?: boolean;
    activePageId?: string | null;
  }
>(({ children, isDrawerOpen, ...rest }, ref): JSX.Element => {
  return (
    <MultiPageStyled ref={ref}>
      <PageBody>
        {children}
        <EnhancedCourseNavigation {...rest} isDrawerOpen={isDrawerOpen} editorContainerRef={ref as RefObject<HTMLDivElement>} />
      </PageBody>
    </MultiPageStyled>
  );
});

MultiPageBody.displayName = 'MultiPageBody';
